import CardListItem from '../../../foundation/ui/controls/card-list-item';
import Level from '../../common/levels';

class TrainCardController
{
  constructor()
  {
    this.name = 'train-card';
    this.props = {
      item: {},
      isModal: {
        default:false,
      },
    };
    this.methods = {
      onTrainClicked: this.onTrainClicked,
    };
    this.data = ()=>({
      address: GLOBAL.cognition,
      img_path:"",
    });
    this.components = {
      CardListItem,
      Level,
    };
    this.mounted = function()
    {
      // debugger;
    };
  }
  onTrainClicked(data)
  {
    this.$emit('item-clicked', {target: this, itemData: this.item});
  }
}

export default TrainCardController;



// WEBPACK FOOTER //
// ./src/components/bz/train-card/controller.js